import { render, staticRenderFns } from "./DeleteTooltip.vue?vue&type=template&id=9e74c2b2&"
import script from "./DeleteTooltip.vue?vue&type=script&lang=js&"
export * from "./DeleteTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports